import { useCallback, useEffect, useRef, useState } from 'react';

export const useInterval = (callback: () => void, interval: number) => {
    const callbackRef = useRef(callback);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const [active, setActive] = useState(false);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const start = useCallback(() => {
        if (intervalRef.current !== null) return;
        setActive(true);
        intervalRef.current = setInterval(() => callbackRef.current(), interval);
    }, [interval]);

    const stop = useCallback(() => {
        if (intervalRef.current === null) return;
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setActive(false);
    }, []);

    useEffect(() => {
        return stop;
    }, [stop]);

    return { start, stop, active };
};
